(function () {
  if (customElements.get('mixed-style-controller')) return;

  class MixedStyleController extends HTMLElement {
    connectedCallback() {
      if (this.started) return;

      if (document.readyState === 'loading') {
        this.readyHandler = () => this.initialize();

        document.addEventListener(
          'DOMContentLoaded',
          this.readyHandler,
          { once: true }
        );
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (this.started || !this.isConnected) return;

      this.picker = document.getElementById(
        this.dataset.pickerId
      );

      this.form = document.getElementById(
        this.dataset.formId
      );

      if (!this.picker || !this.form) return;

      var optionsData = this.querySelector(
        '[data-mixed-options]'
      );

      var variantsData = this.querySelector(
        '[data-mixed-variants]'
      );

      if (!optionsData || !variantsData) return;

      try {
        this.options = JSON.parse(optionsData.textContent);
        this.variants = JSON.parse(variantsData.textContent);
      } catch (error) {
        console.error('Unable to read style picker data.', error);
        return;
      }

      this.groups = Array.from(
        this.picker.querySelectorAll(
          ':scope > .product-form__input'
        )
      );

      this.packIndex = this.groups.findIndex(function (group) {
        return group.classList.contains(
          'product-form__input--quantity-breaks'
        );
      });

      if (this.packIndex < 0) return;

      var styleName = (
        this.dataset.styleName || 'Style'
      ).trim().toLowerCase();

      this.styleIndex = this.options.findIndex(function (option) {
        return option.name.toLowerCase() === styleName;
      });

      if (
        this.styleIndex < 0 ||
        this.styleIndex === this.packIndex
      ) {
        console.warn(
          'Mixed style picker: check the Style option name.'
        );
        return;
      }

      this.styleValues = this.options[
        this.styleIndex
      ].values.map(function (value) {
        return typeof value === 'object' ? value.name : value;
      });

      this.counts = (
        this.dataset.counts || '1,2,3,4,5,6'
      ).split(',').map(function (value) {
        return Number(value.trim());
      });

      var packGroup = this.groups[this.packIndex];

      this.radios = Array.from(
        packGroup.querySelectorAll('input[type="radio"]')
      );

      this.panels = [];
      this.memory = [];
      this.started = true;

      this.radios.forEach((radio, index) => {
        var count = this.counts[index];

        if (
          !Number.isInteger(count) ||
          count < 1 ||
          count > 36
        ) return;

        var card = Array.from(
          packGroup.querySelectorAll('label.quantity-break')
        ).find(function (label) {
          return label.htmlFor === radio.id;
        });

        if (!card) return;

        this.createPanel(card, radio, index, count);
      });

      this.changeHandler = () => this.scheduleUpdate();

      this.picker.addEventListener(
        'change',
        this.changeHandler
      );

      this.observer = new MutationObserver(
        this.changeHandler
      );

      this.observer.observe(this.picker, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'disabled']
      });

      this.submitHandler = (event) => {
        this.update();

        var panel = this.getActivePanel();

        if (!panel) return;

        var invalidSelect = panel.selects.find(function (select) {
          return (
            !select.value ||
            !select.selectedOptions.length ||
            select.selectedOptions[0].disabled
          );
        });

        if (invalidSelect) {
          event.preventDefault();
          event.stopImmediatePropagation();

          panel.shadow.querySelector(
            '.mixed-error'
          ).textContent =
            'Please choose an available style for every piece.';

          invalidSelect.focus();
        }
      };

      this.form.addEventListener(
        'submit',
        this.submitHandler,
        true
      );

      this.update();
    }

    createPanel(card, radio, index, count) {
      var host = document.createElement('div');

      host.className = 'mixed-style-panel';
      host.hidden = true;
      host.style.gridColumn = '1 / -1';

      card.after(host);

      /*
       * 隔离新增下拉框，避免原主题将它们
       * 误认为商品自身的规格选项。
       */
      var shadow = host.attachShadow({ mode: 'open' });

      shadow.innerHTML = `
        <style>
          :host {
            display: block;
            width: 100%;
            min-width: 0;
            margin: -2px 0 12px;
            box-sizing: border-box;
          }

          :host([hidden]) {
            display: none !important;
          }

          * {
            box-sizing: border-box;
          }

          .mixed-box {
            padding: 14px;
            border: 1px solid #bed8e6;
            border-radius: 10px;
            background: #f5fafc;
            color: #263b46;
            font-family: Arial, Helvetica, sans-serif;
          }

          .mixed-title {
            margin: 0 0 12px;
            font-size: 13px;
            font-weight: 600;
            line-height: 1.5;
          }

          .mixed-rows {
            display: grid;
            gap: 10px;
          }

          .mixed-row {
            display: grid;
            grid-template-columns: 64px minmax(0, 1fr);
            align-items: center;
            gap: 10px;
          }

          label {
            font-size: 13px;
            line-height: 1.4;
          }

          select {
            width: 100%;
            min-width: 0;
            min-height: 42px;
            padding: 9px 30px 9px 12px;
            border: 1px solid #b3ccd9;
            border-radius: 7px;
            background: #ffffff;
            color: #263b46;
            font: 14px Arial, Helvetica, sans-serif;
          }

          select:focus-visible {
            outline: 2px solid #278cb7;
            outline-offset: 2px;
          }

          .mixed-error {
            margin: 10px 0 0;
            color: #b42318;
            font-size: 13px;
            line-height: 1.5;
          }

          .mixed-error:empty {
            display: none;
          }

          @media (max-width: 360px) {
            .mixed-box {
              padding: 10px;
            }

            .mixed-row {
              grid-template-columns: 50px minmax(0, 1fr);
              gap: 6px;
            }
          }
        .mixed-box {
  border: 0;
  border-radius: 0;
  background: transparent;
}
          </style>

        <div class="mixed-box">
          <p class="mixed-title">
            Choose a style for each piece
          </p>

          <div class="mixed-rows"></div>

          <p class="mixed-error" role="alert"></p>
        </div>
      `;

      var selects = [];
      var rows = shadow.querySelector('.mixed-rows');

      for (var i = 0; i < count; i++) {
        var row = document.createElement('div');
        row.className = 'mixed-row';

        var label = document.createElement('label');
        label.htmlFor = 'mixed-piece-' + i;
        label.textContent = 'Piece ' + (i + 1);

        var select = document.createElement('select');

        select.id = label.htmlFor;
        select.required = true;

        select.setAttribute(
          'aria-label',
          'Piece ' + (i + 1) + ' style'
        );

        this.styleValues.forEach(function (value) {
          var option = document.createElement('option');

          option.value = value;
          option.textContent = value;

          select.appendChild(option);
        });

        row.append(label, select);
        rows.appendChild(row);
        selects.push(select);
      }

      shadow.addEventListener('change', (event) => {
        event.stopPropagation();

        this.memory[index] = selects.map(function (select) {
          return select.value;
        });

        this.writeProperties();
      });

      shadow.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      this.panels.push({
        host: host,
        shadow: shadow,
        radio: radio,
        index: index,
        selects: selects
      });
    }

    scheduleUpdate() {
      if (this.pending) return;

      this.pending = true;

      queueMicrotask(() => {
        this.pending = false;

        if (this.isConnected) {
          this.update();
        }
      });
    }

    getActivePanel() {
      return this.panels.find(function (panel) {
        return panel.radio.checked;
      });
    }

    getSelectedOptions() {
      return this.groups.map(function (group) {
        var checkedRadio = group.querySelector(
          'input[type="radio"]:checked'
        );

        if (checkedRadio) return checkedRadio.value;

        var select = group.querySelector('select');

        return select ? select.value : undefined;
      });
    }

    update() {
      var selectedOptions = this.getSelectedOptions();

      this.panels.forEach((panel) => {
        panel.host.hidden = !panel.radio.checked;

        if (!panel.radio.checked) return;

        var availableStyles = this.styleValues.filter((style) => {
          return this.variants.some((variant) => {
            if (!variant.available) return false;

            return variant.options.every((value, optionIndex) => {
              if (optionIndex === this.styleIndex) {
                return value === style;
              }

              if (optionIndex === this.packIndex) {
                return value === panel.radio.value;
              }

              return value === selectedOptions[optionIndex];
            });
          });
        });

        panel.selects.forEach((select, pieceIndex) => {
          var saved = this.memory[panel.index];

          var wanted = saved && saved[pieceIndex] !== undefined
            ? saved[pieceIndex]
            : selectedOptions[this.styleIndex];

          Array.from(select.options).forEach(function (option) {
            option.disabled = !availableStyles.includes(
              option.value
            );
          });

          select.value = availableStyles.includes(wanted)
            ? wanted
            : (availableStyles[0] || '');
        });

        this.memory[panel.index] = panel.selects.map(
          function (select) {
            return select.value;
          }
        );

        panel.shadow.querySelector(
          '.mixed-error'
        ).textContent = availableStyles.length
          ? ''
          : 'No styles are available for this package.';
      });

      this.writeProperties();
    }

    writeProperties() {
      this.querySelectorAll(
        '[data-mixed-property]'
      ).forEach(function (input) {
        input.remove();
      });

      var panel = this.getActivePanel();

      if (!panel) return;

      panel.selects.forEach((select, index) => {
        var input = document.createElement('input');

        input.type = 'hidden';
        input.dataset.mixedProperty = '';

        input.name =
          'properties[Piece ' + (index + 1) + ' style]';

        input.value = select.value;

        input.setAttribute(
          'form',
          this.dataset.formId
        );

        this.appendChild(input);
      });
    }

    disconnectedCallback() {
      if (this.readyHandler) {
        document.removeEventListener(
          'DOMContentLoaded',
          this.readyHandler
        );
      }

      if (this.observer) {
        this.observer.disconnect();
      }

      if (this.picker && this.changeHandler) {
        this.picker.removeEventListener(
          'change',
          this.changeHandler
        );
      }

      if (this.form && this.submitHandler) {
        this.form.removeEventListener(
          'submit',
          this.submitHandler,
          true
        );
      }

      if (this.panels) {
        this.panels.forEach(function (panel) {
          panel.host.remove();
        });
      }

      this.started = false;
    }
  }

  customElements.define(
    'mixed-style-controller',
    MixedStyleController
  );
})();